import React from "react";
import SafeFontAwesomeIcon from "../../SafeFontAwesomeIcon";

function Icon({
  Icon,
  color = "#c4c4c4",
  size,
  iconSize,
  swapOpacity,
  spin,
  plus,
  flip,
  rotation,
  border,
  onClick,
  style = {},
  className = "",
}) {
  return (
    <SafeFontAwesomeIcon
      className={className}
      onClick={onClick}
      icon={Icon}
      style={{ color: color, fontSize: size ? size : 16, ...style }}
      swapOpacity={swapOpacity}
      spin={spin}
      pulse={plus}
      flip={flip}
      rotation={rotation}
      border={border}
    />
  );
}

export default Icon;
